import { Link } from "react-router-dom";
import { DocumentIcon, LinkIcon, PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useAppSelector } from "../../app/hooks";
import { AlertLevel } from "../../components/AlertMessage";
import ButtonWithConfirm from "../../components/ButtonWithConfirm";
import { StimulusMaterialViewModel } from "./stimulusMaterialApiSlice";

interface StimulusMaterialsProps {
	stimuli: Array<StimulusMaterialViewModel>;
	className?: string;
	linkClassName?: string;
	hideTitle?: boolean;
	onEdit?: (stimId: number) => void;
	onDelete?: (stimId: number) => void;
}

export function StimulusMaterial({
	stimuli,
	className,
	linkClassName = "",
	hideTitle,
	onEdit,
	onDelete,
}: StimulusMaterialsProps) {
	if (!stimuli || stimuli.length == 0) return <></>;

	const { aspUrl } = useAppSelector((state) => state.site);

	return (
		<div className={className}>
			{!hideTitle && <h4 className="font-medium">Stimulus Material</h4>}
			<ul>
				{stimuli.map((stimulus, index) => (
					<li key={`stimulus-${index}`} className="flex items-center">
						{stimulus.url ? (
							<div className="flex items-center">
								<LinkIcon className="h-3 w-3 mr-2" />
								<a
									href={stimulus.url}
									className={`cursor-pointer ${stimulus.id == 0 ? "pointer-events-none text-gray-900" : ""} ${linkClassName}`}
									target="_blank"
									rel="noopener noreferrer">
									{stimulus.label}
								</a>
							</div>
						) : (
							<div className="flex items-center">
								<DocumentIcon className="h-3 w-3 mr-2" />
								<Link
									className={`cursor-pointer ${stimulus.id == 0 ? "pointer-events-none text-gray-900" : ""} ${linkClassName}`}
									to={`${aspUrl}/Prompt/DownloadStimulusMaterial?id=${stimulus.id}`}
									download={true}>
									{stimulus.label}
								</Link>
							</div>
						)}
						{onEdit && (
							<PencilIcon
								className="size-4 inline ml-4 cursor-pointer"
								onClick={() => onEdit(stimulus.id === 0 ? index : stimulus.id)}
							/>
						)}
						{onDelete && (
							<ButtonWithConfirm
								id={`delete-stim-${index}-button`}
								className="ml-3 cursor-pointer"
								message={`Are you sure you want to delete "${stimulus.label}" from this prompt?`}
								type={AlertLevel.Warning}
								confirmLabel="Yes"
								cancelLabel="No"
								onConfirm={() => onDelete(stimulus.id === 0 ? index : stimulus.id)}>
								<TrashIcon className="size-4 inline" />
							</ButtonWithConfirm>
						)}
					</li>
				))}
			</ul>
			<p className="text-xs mt-2">
				NOTE: Measurement Incorporated does not control any of the content on the stimulus
				material pages.
			</p>
		</div>
	);
}
